export const compStyles = {
  methods: {
    toggleActive: function (n) {
      if (n == this.disp_key) {
        this.cls = "component in";
      } else {
        this.cls = "component out";
      }
    },
  },
};
